<template>
    <div class="card">
        <div class="card-header text-black p-2">
            <div class="d-flex justify-content-between align-items-center">
                <span>Pending Tasks({{ this.moment(serviceDate).format('D MMM, YYYY')}})</span>
                <div class="d-flex gap-1 align-items-center">
                    <div>
                        <input 
                            v-model="search" 
                            type="text" 
                            name="search"
                            id="search"
                            class="form-control form-control-sm"
                            placeholder="Search..." 
                            autocomplete="off"
                        >
                    </div>
                    <PreviousDateIcon v-model="serviceDate" />
                    <NextDateIcon v-model="serviceDate" />
                    <CalendarIcon v-model="serviceDate" :auto-apply="true" />
                </div>
            </div>
        </div>
        <div class="card-body overflow-auto p-2" style="height: 200px;">
            <div class="table-responsive">
                <table class="table hm-fs-12 align-middle table-hover table-sm">
                    <thead>
                        <tr>
                            <th scope="col" class="bg-theme">Client</th>
                            <th scope="col" class="bg-theme" width="80px">Post Code</th>
                            <th scope="col" class="bg-theme">Phone</th>
                            <th scope="col" class="bg-theme">Type</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-if="filteredOrders.length > 0"
                            v-for="order in filteredOrders"
                            :key="order.id"
                            @click="$goToPage(`/admin/orders/${order.order_number}`)"
                            class="cursor-pointer"
                        >
                            <td :title="order.customer.name">{{ formatName(order.customer.name) }}</td>
                            <td>{{ order.address.postal_code }}</td>
                            <td>{{ order.customer.phone_number }}</td>
                            <td>{{ isProvisionalOrder(order) ? 'Provisional' : 'Confirmed' }}</td>
                        </tr>
                        <tr v-else-if="processing">
                            <td colspan="4" class="text-center">
                                <Loader />
                            </td>
                        </tr>
                        <tr v-else>
                            <td colspan="4" class="text-center">No orders found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import { appMixin } from '../../mixin/appMixin';
import Loader from '../partials/Loader';
import CalendarIcon from '../partials/CalendarIcon';
import NextDateIcon from '../partials/NextDateIcon';
import PreviousDateIcon from '../partials/PreviousDateIcon';

export default {
    name: 'PendingTasks',
    components: {
        Loader,
        CalendarIcon,
        NextDateIcon,
        PreviousDateIcon
    },
    mixins: [appMixin],
    data() {
        return {
            orders: [],
            processing: true,
            search: '',
            serviceDate: this.moment(new Date()),
        }
    },
    mounted() {
        this.getOrders();

        this.$emitter.on('refresh-order-list', (data) => {
            this.getOrders();
        });
    },
    computed: {
        filteredOrders() {
            // Search in the following
            // Fields: order.order_number,order.address.full_address,
            // order.customer.name,order.customer.email,order.customer.phone_number
            return this.orders.filter(order => {
                return order.order_number.toLowerCase().includes(this.search.toLowerCase()) ||
                    order.address.full_address.toLowerCase().includes(this.search.toLowerCase()) ||
                    order.customer.name.toLowerCase().includes(this.search.toLowerCase()) ||
                    order.customer.email.toLowerCase().includes(this.search.toLowerCase()) ||
                    order.customer.phone_number.toLowerCase().includes(this.search.toLowerCase());
            });
        }
    },
    watch: {
        serviceDate() {
            this.getOrders();
        }
    },
    methods: {
        getOrders() {
            this.processing = true;
            axios.post('/api/admin/task-summary', {
                service_date: this.serviceDate
            })
                .then(response => {
                    this.orders = response.data.orders;
                    this.processing = false;
                })
                .catch(error => {
                    console.error(error);
                    this.processing = false;
                });
        }
    }
}
</script>
